import "./TurnIndicator.scss";
import { useGame } from "../../../context/GameContext";
import { useMultiplayer } from "../../../context/MultiplayerContext";

/**
 * Indicates whose turn it is in the game.
 * @returns the current turn indicator
 */
export default function TurnIndicator() {
    const { gameState } = useGame();
    const { multiplayerState } = useMultiplayer();

    if (!gameState.game) return null;
    if (gameState.isAIGame) return null;
    if (gameState.game.isGameOver()) return null;
    if (multiplayerState.isHost) return null;
    if (multiplayerState.forfeit.isForfeit) return null;

    const isMyTurn = gameState.game.turn() === multiplayerState.playerColor;

    const className = isMyTurn ? "flashing-turn" : "";
    const text = isMyTurn ? `It's your turn!` : `Opponents move...`;

    if (gameState.isPuzzle) {
        const currentTurn = gameState.game.turn();
        const turnText = currentTurn === "w" ? "White to move" : "Black to move";
        return (
            <div id="current-turn" className="">
                {turnText}
            </div>
        );
    }

    return (
        <div id="current-turn" className={className}>
            {text}
        </div>
    );
}
